import React from 'react'
import { useNavigate } from 'react-router-dom'
import { PageHeader } from '@components/common'
import { ProjectWizard } from '@components/features/projects'
import './NewProject.scss'

/**
 * New Project Page
 *
 * Renders the multi-step project onboarding wizard
 */
const NewProject = () => {
	const navigate = useNavigate()

	const handleComplete = (project) => {
		// Navigate to the project details page after successful creation
		navigate(`/projects/${project.id}`)
	}

	const handleCancel = () => {
		// Navigate back to dashboard or projects list
		navigate('/dashboard')
	}

	return (
		<div className="new-project-page">
			<PageHeader
				title="New Project"
				description="Create a new compliance project using the guided wizard"
				breadcrumbs={[
					{ label: 'Projects', path: '/dashboard' },
					{ label: 'New Project' }
				]}
			/>
			<ProjectWizard onComplete={handleComplete} onCancel={handleCancel} />
		</div>
	)
}

export default NewProject
